import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { FONTS } from 'styles/theme/fonts';
import { COLORS } from 'styles/theme/colors';

export const TableButton = ({ text, onClick, tab }) => {
  return (
    <TableButton.StyledTableButton onClick={onClick} tab={tab}>
      {text}
    </TableButton.StyledTableButton>
  );
};

TableButton.StyledTableButton = styled.button`
  background-color: ${COLORS.primaryButtonBackground};
  font-family: ${FONTS.emphasized};
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.5px;
  font-weight: 500;
  color: ${COLORS.primaryButtonText};
  margin-bottom: 8px;
  cursor: pointer;
  border: none;
  text-transform: capitalize;
  padding: 10px 18px 10px 18px;
  width: 209px;
  height: 40px;

  &:hover {
    background-color: ${COLORS.primaryTableButtonBackground};
    color: ${COLORS.primaryText};
  }

  &:focus {
    outline: none;
  }
`;

TableButton.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  tab: PropTypes.string,
};

export default TableButton;
